import { render, staticRenderFns } from "./ESimpleKeyboard.vue?vue&type=template&id=2ddd3d02&scoped=true&"
import script from "./ESimpleKeyboard.vue?vue&type=script&lang=js&"
export * from "./ESimpleKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./ESimpleKeyboard.vue?vue&type=style&index=0&id=2ddd3d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd3d02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddd3d02')) {
      api.createRecord('2ddd3d02', component.options)
    } else {
      api.reload('2ddd3d02', component.options)
    }
    module.hot.accept("./ESimpleKeyboard.vue?vue&type=template&id=2ddd3d02&scoped=true&", function () {
      api.rerender('2ddd3d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ESimpleKeyboard.vue"
export default component.exports